import React, { useEffect, useState } from "react";

const Select = ({ name, onChange, options, placeholder, optional }: any) => {
  const [opts, setOpts] = useState([]);

  useEffect(() => {
    const result = options.value.split("\n");
    setOpts(result);
  }, []);

  return (
    <div>
      <label className="block text-sm font-medium leading-6 text-gray-900">
        {name}{" "}
        {optional && <span className="text-gray-700 text-xs">(Opcional)</span>}
      </label>
      <select
        name={name}
        id={name}
        style={{ height: "36px" }}
        className="block w-full mt-2 px-1 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
      >
        {placeholder && (
          <option value="" disabled selected>
            {placeholder}
          </option>
        )}
        {opts?.map((item: string) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
